module.exports = __webpack_public_path__ + "img/30292-6.prt.c389bec9.jpg";